import { Typography, Box } from '@mui/material';

import BannerValidateData from 'assets/images/banner-validate-data.png';
import { ReactComponent as IcIturan } from 'assets/icons/ic-ituran.svg';

const BannerSideBar = () => {
    return (
        <Box bgcolor='#1E5F91' position='relative' textAlign='center' sx={{ width: { xs: '100%', md: '38%' } }}>
            <Box sx={{
                textAlign: 'center',
                'svg': {
                    position: 'absolute',
                    inset: 0,
                    top: { xs: '.62rem', md: '3.2rem' },
                    margin: '0 auto',
                    height: { xs: '3.125rem', md: '4.2rem' }
                }
            }}>
                <IcIturan />
            </Box>

            <Box sx={{ padding: { xs: '5rem 1rem 1.4rem', md: '30% 1rem 0' } }}>
                <Typography color='white' fontWeight={700} sx={{
                    fontSize: { xs: '1.25rem', md: '1.875rem' },
                    paddingBottom: { xs: '.5rem', md: '.7rem' }
                }}>
                    Check-in do agendamento!
                </Typography>
                <Typography sx={{
                    fontSize: { xs: '.9375rem', md: '1.25rem' },
                    color: 'white',
                    maxWidth: '26rem',
                    margin: '0 auto'
                }}>
                    Para darmos continuidade ao processo, <b>faça o check-in agora</b> e evite atrasos!
                </Typography>
            </Box>

            <Box sx={{
                display: { xs: 'none', md: 'grid' },
                position: 'absolute',
                bottom: '-4px',
                margin: '0 auto',
                justifyContent: 'center',
                'img': {
                    width: '100%',
                    height: 'auto'
                }
            }} >
                <img src={BannerValidateData} alt='token ilustrativo' />
            </Box>
        </Box>
    );
}

export default BannerSideBar;